import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  subtitle: string;
  category: string;
  author: string;
  coverUrl: string;
  rating: number;
  views: number;
  chapters: number;
  status: string;
  tags: string[];
  isFirst?: boolean;
}

export default function ComicCard({
  id,
  title,
  subtitle,
  category,
  author,
  coverUrl,
  rating,
  views,
  chapters,
  status,
  tags,
  isFirst,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <article className="group" data-product-shop>
      <Link to={`/article/${id}`} className="block">
        <div className="relative overflow-hidden rounded-lg aspect-[7/10] mb-3">
          <img
            src={coverUrl}
            alt={`${title} - ${subtitle}`}
            title={`${title} ${subtitle} - 韩国漫画无删减`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute top-2 left-2 flex gap-1 flex-wrap">
            {tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 text-[10px] font-medium bg-primary-500/90 text-background-50 dark:text-foreground-950 rounded-full whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-3">
            <div className="flex items-center justify-between">
              <span className="text-[10px] text-background-50/90 flex items-center gap-1 whitespace-nowrap">
                <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                {rating}
              </span>
              <span className="text-[10px] text-background-50/80 whitespace-nowrap">
                {chapters}话
              </span>
            </div>
          </div>
        </div>

        <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mb-2 whitespace-nowrap">
          {author} · {formatViews(views)}阅读
        </p>
      </Link>

      <Link
        to={`/article/${id}`}
        className={`block w-full text-center py-2 text-xs font-medium rounded-full transition-all duration-200 whitespace-nowrap ${
          isFirst
            ? 'bg-primary-500 text-background-50 dark:text-foreground-950 hover:bg-primary-600'
            : 'bg-background-50 border border-foreground-200 text-foreground-700 hover:bg-primary-50 hover:border-primary-300 hover:text-primary-600'
        }`}
      >
        {isFirst ? '立即阅读' : '开始阅读'}
      </Link>
    </article>
  );
}